import { render } from "./BankOptions.vue?vue&type=template&id=940fde60&scoped=true"
import script from "./BankOptions.vue?vue&type=script&lang=js"
export * from "./BankOptions.vue?vue&type=script&lang=js"

import "./BankOptions.vue?vue&type=style&index=0&id=940fde60&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-940fde60"]])

export default __exports__